export interface IReviewInitialValues {
    base64EncodedImage: string;
    acceptSubmitting: boolean;
}

export const reviewInitialValues: IReviewInitialValues = {
    base64EncodedImage: '',
    acceptSubmitting: false
};